import { makeStyles, Typography } from '@material-ui/core';
import { Grid } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomButton from '../../shared/CustomButton';
import RnpAddNewPopup from './RnpAddNewPopup';
import CustomCard from '../../shared/CustomCard';
import { rnpMenuList } from '../constants';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import { showProgress } from '../../../redux/actions/DealershipActions';
import ConfirmationDialog from '../../common/ConfirmationDialog';
import DeleteIcon from '../../../assets/DeleteIcon';

const MainContainer = ({ fetchData }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const rnpDetails = useSelector((state) => state.rnpData.rnpDetails);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const handleOpenAddPopup = () => setIsAddOpen(true);
  const handleCloseAddPopup = () => setIsAddOpen(false);
  const handleCloseEditPopup = () => setIsEditOpen(false);
  const handleDeleteConfirmClose = () => setOpenDeleteConfirm(false);
  const deleteRNP = useCallback(async () => {
    setOpenDeleteConfirm(false);
    dispatch(showProgress(true));
    try {
      await service.delete(apiEndpoints.DELETE_RNP.replace('ID', selectedId));
      notifySuccess('RNP Successfully Deleted');
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
    fetchData();
  }, [dispatch, fetchData, selectedId]);
  const handleMenuItemClick = async (e, name) => {
    const clickedId = e.currentTarget.getAttribute('data-id');
    if (name === 'Edit RNP') {
      setIsEditOpen(true);
      setSelectedId(clickedId);
    } else {
      setSelectedId(clickedId);
      setOpenDeleteConfirm(true);
    }
  };
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.titleContainer}
        >
          <Grid item>
            <Typography className={classes.title}>RNPs</Typography>
          </Grid>
          <Grid item>
            <CustomButton type="primary" label="+ Add RNP" size="large" onClick={handleOpenAddPopup} />
            {isAddOpen && <RnpAddNewPopup close={handleCloseAddPopup} add title="RNP" fetchData={fetchData} />}
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="row" spacing={1} className={classes.mainContainer} alignContent="flex-start">
          {rnpDetails?.partners?.map((partner) => (
            <Grid item>
              <CustomCard
                id={partner?.id}
                height="56px"
                width="300px"
                title={partner?.name}
                thumbnail={partner?.logo}
                thumbnailSize="32px"
                menu
                menuItems={rnpMenuList}
                handleMenuItemClick={handleMenuItemClick}
                grey
              />
            </Grid>
          ))}
          {isEditOpen && (
            <RnpAddNewPopup
              key={selectedId}
              close={handleCloseEditPopup}
              add={false}
              title="RNP"
              id={selectedId}
              fetchData={fetchData}
            />
          )}
          {openDeleteConfirm && (
            <ConfirmationDialog
              title="Are you sure you want to delete this RNP?"
              subText="Once done you cannot undo this action."
              onClose={handleDeleteConfirmClose}
              isOpen={openDeleteConfirm}
              confirmFn={deleteRNP}
              disagreeText="Cancel"
              agreeText="Delete"
              Icon={DeleteIcon}
              width="335px"
              height="229px"
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  titleContainer: {
    background: '#F2F4F7',
    padding: '8px',
    borderBottom: '1px solid #E4E7EC',
  },
  title: {
    fontFamily: 'Lato',
    fontWeight: '700 ',
    fontSize: '16px',
    lineHeight: '22.4px ',
    color: '#10182B',
  },
  mainContainer: {
    height: '70vh',
    overflowY: 'auto',
  },
});
export default MainContainer;
